// extracted by mini-css-extract-plugin
export default {"footer-item":"FooterItem_footer-item__IUh5+"};